module.exports = __webpack_public_path__ + "assets/images/4d6e287b3fc92e6985eafb1fc2c5b096.svg";